<template>
  <router-view v-if="$store.getters.appIsInitialized"/>
</template>

<script>
import {APP_INITIALIZE} from "@/store/modules/app/actions";
import {APP_INITIALIZE_DONE, APP_INITIALIZE_FAILED} from "@/events/app";
import {AUTH_LOGOUT} from "@/store/modules/auth/actions";

export default {
  name: "HomeLayout",
  methods: {
    onAppInitializationFailed() {
      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({name: "login"})
    },
    onAppInitializationDone() {
      this.redirect()
    },
    redirect() {
      if (this.$store.getters.appIsWebClient) {
        if (this.$route.name !== "web-client-dashboard")
          this.$router.push({name: "web-client-dashboard"})
      } else {
        if (this.$route.name === "home") {
          this.$router.push({name: "dashboard"})
        }
      }
    },
    onLogout() {
      this.$router.push({name: "login"})
    },
  },
  created() {
    this.$bus.$on(AUTH_LOGOUT, this.onLogout)
    this.$bus.$on(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
    this.$bus.$on(APP_INITIALIZE_DONE, this.onAppInitializationDone)

    if (this.$store.getters.appIsInitialized)
      this.redirect()
    else
      this.$store.dispatch(APP_INITIALIZE)
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_LOGOUT, this.onLogout)
    this.$bus.$off(APP_INITIALIZE_FAILED, this.onAppInitializationFailed)
    this.$bus.$off(APP_INITIALIZE_DONE, this.onAppInitializationDone)
  }
}
</script>

<style scoped>

</style>